/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Status_DeliveredInputs */

const vi_cdo_status_delivered = /** @type {(inputs: Cdo_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao`)
};

/**

* @param {Cdo_Status_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_status_delivered = /** @type {((inputs?: Cdo_Status_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Status_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_status_delivered(inputs)
});